var _rect, _path, _path2, _circle, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9288 66.9261C85.4993 64.4967 82.6152 62.5696 79.441 61.2548C76.2668 59.94 72.8648 59.2633 69.4291 59.2633C65.9934 59.2633 62.5913 59.94 59.4171 61.2548C56.2429 62.5696 53.3588 64.4967 50.9294 66.9261C48.5 69.3555 46.5728 72.2396 45.2581 75.4138C43.9433 78.588 43.2666 81.9901 43.2666 85.4258C43.2666 88.8615 43.9433 92.2636 45.2581 95.4377C46.5728 98.6119 48.5 101.496 50.9294 103.925L69.4291 85.4258L87.9288 66.9261Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.501 66.9261C170.93 64.4967 173.814 62.5696 176.989 61.2548C180.163 59.94 183.565 59.2633 187.001 59.2633C190.436 59.2633 193.838 59.94 197.013 61.2548C200.187 62.5696 203.071 64.4967 205.5 66.9261C207.93 69.3555 209.857 72.2396 211.172 75.4138C212.486 78.588 213.163 81.9901 213.163 85.4258C213.163 88.8615 212.486 92.2636 211.172 95.4377C209.857 98.6119 207.93 101.496 205.5 103.925L187.001 85.4258L168.501 66.9261Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 139,
    r: 70,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 41,
    width: 32,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 56,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 98,
    width: 12,
    height: 48,
    rx: 6,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 134,
    width: 12,
    height: 49,
    rx: 6,
    transform: "rotate(90 171 134)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour);
export default __webpack_public_path__ + "static/media/hour.b9e30348e2765630df99eae963873853.svg";
export { ForwardRef as ReactComponent };